import React, { useState, useEffect } from "react";

const Thumbnail = ({ file, index }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 2;

  useEffect(() => {
    // 파일 URL이 변경되면 상태 초기화
    setHasError(false);
    setIsLoading(true);
    setRetryCount(0);
  }, [file]);

  // 403 에러 발생 시 재시도 로직
  const handleImageError = () => {
    if (retryCount < MAX_RETRIES) {
      // 일정 시간 후에 재시도
      setTimeout(() => {
        setRetryCount((prev) => prev + 1);
        // 이미지를 강제로 새로고침하기 위해 캐시 방지 쿼리 파라미터 추가
        const imgElement = document.getElementById(`thumbnail-img-${index}`);
        if (imgElement) {
          imgElement.src = `${file}?retry=${Date.now()}`;
        }
      }, 2000); // 2초 후 재시도
    } else {
      setHasError(true);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <span>로딩 중...</span>}

      {hasError ? (
        <span>이미지를 불러올 수 없습니다.</span>
      ) : (
        <img id={`thumbnail-img-${index}`} src={file} alt={`thumbnail-${index}`} onError={handleImageError} onLoad={() => setIsLoading(false)} style={{ display: isLoading ? "none" : "block" }} />
      )}
    </>
  );
};
export default Thumbnail;
